var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-input-wrapper"
  }, [_c('MessageInputQuote', {
    on: {
      "getQuoteMessageCloudCustomData": _vm.getQuoteMessageCloudCustomData
    }
  }), _c('div', {
    class: ['message-input-container', !_vm.isPC && 'message-input-container-h5']
  }, [_vm.shouldShowAudio ? _c('div', {
    staticClass: "audio-icon",
    on: {
      "click": _vm.audioShow
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.isInAudioMode ? _vm.keyboardIcon : _vm.audioIcon,
      "width": "24px",
      "height": "24px"
    }
  })], 1) : _vm._e(), _c('MessageInputEditor', {
    ref: "editor",
    attrs: {
      "placeholder": _vm.placeholder,
      "isMuted": _vm.props.isMuted,
      "muteText": _vm.props.muteText,
      "enableInput": _vm.props.enableInput,
      "enableTyping": _vm.props.enableTyping,
      "enableDragUpload": _vm.props.enableDragUpload,
      "isInAudioModeFromProps": _vm.isInAudioMode,
      "shouldShowToolbar": _vm.shouldShowToolbar,
      "shouldShowEmoji": _vm.shouldShowEmoji,
      "shouldShowAudio": _vm.shouldShowAudio
    },
    on: {
      "sendMessage": _vm.sendMessage,
      "onTyping": _vm.onTyping,
      "blurToolAndEmojiH5": _vm.blurToolAndEmojiH5,
      "isInputNotEmpty": _vm.isInputNotEmpty
    }
  }), !_vm.props.isMuted && _vm.isPC ? _c('MessageInputButton', {
    on: {
      "sendMessage": _vm.sendMessage
    }
  }) : _vm._e(), _vm.isH5 && _vm.shouldShowEmoji ? _c('div', {
    class: ['emoji-icon', !_vm.shouldShowToolbar && _vm.isH5 ? 'emoji-h5-no-toolbar' : ''],
    attrs: {
      "id": "emoji-icon-h5"
    },
    on: {
      "click": _vm.emojiShow
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.emojiIcon,
      "width": "24px",
      "height": "24px"
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isH5 && _vm.shouldShowToolbar && !_vm.showSendButton,
      expression: "isH5 && shouldShowToolbar && !showSendButton"
    }],
    staticClass: "tool-icon",
    on: {
      "click": _vm.toolShow
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.toolIcon,
      "width": "24px",
      "height": "24px"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isH5 && _vm.showSendButton,
      expression: "isH5 && showSendButton"
    }],
    staticClass: "send-button-h5",
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.sendButtonIcon,
      "width": "34px",
      "height": "34px"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }